import { createAction, props } from '@ngrx/store';

export const reset = createAction('Reset');
